/**
 * @generated SignedSource<<f5148a770c9b1635a723a692562359ee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type adminDashboard_ActiveUsersQuery$variables = Record<PropertyKey, never>;
export type adminDashboard_ActiveUsersQuery$data = {
  readonly adminActiveUsers: ReadonlyArray<{
    readonly accessGrantedAt: string | null | undefined;
    readonly activatedAt: string | null | undefined;
    readonly categoriesCount: number;
    readonly dataRevealedAt: string | null | undefined;
    readonly email: string;
    readonly estimatedMrr: number | null | undefined;
    readonly filesCount: number;
    readonly id: string;
    readonly lastActivityAt: string | null | undefined;
    readonly publicSlug: string | null | undefined;
    readonly rowsTotal: number;
    readonly stakeholdersCount: number;
    readonly transactionsCount: number;
  }>;
};
export type adminDashboard_ActiveUsersQuery = {
  response: adminDashboard_ActiveUsersQuery$data;
  variables: adminDashboard_ActiveUsersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminActiveUser",
    "kind": "LinkedField",
    "name": "adminActiveUsers",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "email",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "activatedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "accessGrantedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastActivityAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "dataRevealedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "publicSlug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "filesCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rowsTotal",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "transactionsCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "categoriesCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "stakeholdersCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "estimatedMrr",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "adminDashboard_ActiveUsersQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "adminDashboard_ActiveUsersQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "2cc32fc648dd078f5dfd5069e626d658",
    "id": null,
    "metadata": {},
    "name": "adminDashboard_ActiveUsersQuery",
    "operationKind": "query",
    "text": "query adminDashboard_ActiveUsersQuery {\n  adminActiveUsers {\n    id\n    email\n    activatedAt\n    accessGrantedAt\n    lastActivityAt\n    dataRevealedAt\n    publicSlug\n    filesCount\n    rowsTotal\n    transactionsCount\n    categoriesCount\n    stakeholdersCount\n    estimatedMrr\n  }\n}\n"
  }
};
})();

(node as any).hash = "ba565ec66961be6fa9f8cbc92e232ae3";

export default node;
